(function() {
    'use strict';
    
a3_cabin_reports.factory('CabinReportLocalEditCreatorFactory',CabinReportLocalEditCreatorFactory);
    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name CabinReportLocalEditCreatorFactory
    * @description 
    *  Create a new local Report
    * @ngInject
    */
function CabinReportLocalEditCreatorFactory(FlightFactory, ReportGuidFactory, CabinReportTemplateItemFactory, CabinReportLocalEditFactory, UserFactory, CCMSCrewPositionFactory, GroundServicesFactory, FlightOrdersFactory) {

		var service = {
				createNewLocalReportForFlight : createNewLocalReportForFlight
		}
		
        /**
         * Create a new Local Report For the Selected Flight
         * @memberof CrewAssessmentFactory
         * @param {number} flightId 
         * @returns {object} report 
         */
		function createNewLocalReportForFlight(flightId) {

			// load the user
			var user = UserFactory.getUser();
			if (user == null)
				return null;

			// check if a report exists for this flight and user
			var existingReport = CabinReportLocalEditFactory.getCabinReportLocalEditForFlight(flightId);
			if (existingReport != null)
				return existingReport;

			// get a guid for the report
			var newReportGuid = ReportGuidFactory.getNextGuid();
			if (newReportGuid == null)
				return null;

			// load the cabin report template
			var reportTemplateItems = CabinReportTemplateItemFactory.getCabinReportTemplateItemsFromStorage();
			if (reportTemplateItems == null)
				return null;
			if (reportTemplateItems.length == 0)
				return null;

			// load the flight
			var flight = FlightFactory.getFlightFromStorage(flightId);
			if (flight == null) {
				// if not found, also check the local flights
				var flight = FlightFactory.getLocalFlightFromStorage(flightId);

				// if still not found, then return null
				if (flight == null)
					return null;
			}

			// create the new report
			var newReport = CabinReportLocalEditFactory.getNewReport();

			// assign data on the new report
			newReport.AuthorId = user.id;
			newReport.AuthorAimsId = user.aimsId;
			newReport.AuthorName = user.name;
			newReport.Created = new Date();
			newReport.FlightAimsId = flight.FlightAimsId;
			newReport.FlightId = flight.FlightId;
			newReport.LastUpdated = new Date();
			newReport.AcType = flight.AcType;
			newReport.AcTailNo = flight.AcTailNo;
			newReport.FlightDate = flight.FlightDate;
			newReport.FlightNo = flight.FlightNo;
			newReport.Departure = flight.Departure;
			newReport.Arrival = flight.Arrival;
			newReport.ScheduledDeparture = flight.ScheduledDeparture;
			newReport.ScheduledDepartureDateUTC = flight.ScheduledDepartureDateUTC;
			newReport.ScheduledDepartureTimeUTC = flight.ScheduledDepartureTimeUTC;
			newReport.ReportGuid = newReportGuid;
			newReport.ReportId = null;
			newReport.Status = 'pending';
			newReport.WaterUpliftSuggestedQuantity = flight.WaterUpliftSuggestedQuantity; // TODO
			newReport.VariousIssues = reportTemplateItems;
			//details from flight (assuming flight contains these fields)
			if (flight.DepartureName) {
				newReport.DepartureICAO = flight.DepartureICAO;
				newReport.DepartureCountry = flight.DepartureCountry;
				newReport.DepartureName = flight.DepartureName;
				newReport.ArrivalICAO = flight.ArrivalICAO;
				newReport.ArrivalCountry = flight.ArrivalCountry;
				newReport.ArrivalName = flight.ArrivalName;
			}
			//pax figures from flight (assuming flight contains these figures)
			if (flight.BookedY >= 0) {
				newReport.BookedC = flight.BookedC;
				newReport.BookedY = flight.BookedY;
				newReport.BookedInf = flight.BookedInf;
				newReport.BookedPad = flight.BookedPad;
				newReport.BookedChld = flight.BookedChld;
				newReport.ActualC = flight.ActualC;
				newReport.ActualY = flight.ActualY;
				newReport.ActualInf = flight.ActualInf;
				newReport.ActualPad = flight.ActualPad;
				newReport.ActualChld = flight.ActualChld;
			}

			// fix the CCMS positions
			for (var i = 0; i < flight.crew.length; i++) {

				if ((flight.crew[i].isDHC == false) &&
					(flight.crew[i].position != 'CP') &&
					(flight.crew[i].position != 'FO')) {
					var crewPosition = CCMSCrewPositionFactory.createNew();
					crewPosition.CrewId = flight.crew[i].aimsId;
					crewPosition.Initials = flight.crew[i].shortname;
					crewPosition.Name = flight.crew[i].name;
					crewPosition.Position = flight.crew[i].position;
					crewPosition.IsManual = false;
					crewPosition.CrewComments = null;
					crewPosition.HasCrewComments = false;
					crewPosition.needsAdditionalFeedback = false;
					newReport.CCMSCrewPositions.push(crewPosition);
				}
			}
			newReport.crew = flight.crew;

			//new values
			newReport.DepartureTimezone = flight.DepartureTimezone;
			newReport.ArrivalTimezone = flight.ArrivalTimezone;
			newReport.CallSign = flight.CallSign;
			newReport.ScheduledArrival = flight.ScheduledArrival;
			newReport.DepartureGate = flight.DepartureGate;
			newReport.Route = flight.Route;
			newReport.DutyDate = flight.DutyDate;

			//add ground services
			newReport.DepartureGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Departure);
			//We don't show arrival services any more...  
			//newReport.ArrivalGroundServices = GroundServicesFactory.getGroundServicesByStation(flight.Arrival);

			//add flightOrders in report
			newReport.FlightOrders = FlightOrdersFactory.getFlightOrdersForCreateReportByFlightId(flight.FlightId);
			newReport.GroomingReports = [];

			newReport.updateTotals();

			// return the new report
			return newReport;
		}

		return service;
}

})();